import React, { memo, useState, useEffect, useRef } from 'react';
import { useDispatch, connect } from 'react-redux';
import AnalysisSummary, { expandData } from './summary';
import { formatFinancials } from './summary/financials';
import Dropdown from '@components/dropdown';
import AnalysisDetail, { allRightComponent } from './detail';
import { formatFun, resortFun } from './summary/keyExecutives/formUtils';
import { API } from '@service';
import actions from '@flux/action';
import moment from 'moment';
import InsightModal from './insightModal';
import { filterXSS } from 'xss';
// import { isUuid } from '@utils/common';
import {
  SEGMENTS,
  UNCLICKABLE_RESOURCE_NAME,
  CSTMZ_SEGMENTS,
  getMenuList,
} from '@model';
import {
  ANALYSIS_BREADCRUMB_PREFIX,
  analysisRouteWhiteList,
} from '../../container/routes';
import { fixModuleName } from '@utils/widget';

import { getProjectInfoFromLocation } from '@utils/history';
import { generateProjectUrlSearch, sliceStr, isUuid } from '@utils/common';

import AnalysisCstmzWrapper from './analysisCstmzWrapper';
import Footer from './summary/summaryFooter';
// import '@style/modules/analysis/analysis.scss';
// import '@style/modules/analysis/keyContacts.scss';
import '../../styles/modules/analysis/analysis.scss';
import '../../styles/modules/analysis/keyContacts.scss';
import FieldSettings from './summary/fieldsSettings';
import { FinancialUpload } from './summary/financialUpload';
import { GlobalEditButton } from './summary/globalEditable';
import action from '@flux/action';

const RESOURCE_HAS_SINGLECHART = [
  'Employee Headcount',
  'Company Description',
  'Headquarters',
  'Ticker and Stock Exchange',
  'Acquisition History',
  'Company History',
];

// const defaultMenuList = Object.keys(SEGMENTS).map((seg) => ({
//   id: seg,
//   title: SEGMENTS[seg],
// }));

const defaultValue = [
  [
    SEGMENTS.companyoverview,
    { resourceId: 'cd', resourceName: 'Company Description' },
  ],
  [
    SEGMENTS.gotomarket,
    { resourceId: 'totalRevenue', resourceName: 'Total Revenue' },
  ],
  [
    SEGMENTS.financials,
    // { resourceId: 'totalRevenue', resourceName: 'Total Revenue' },
    { resourceId: 'setResourceId', resourceName: 'SG&A Expense' },
  ],
  [
    SEGMENTS.operationalfootprint,
    { resourceId: 'loc', resourceName: 'Locations' },
  ],
];

const valueForChoosedMenu = new Map(defaultValue);

const clearLocationState = (history = {}, target, projectId) => {
  if (analysisRouteWhiteList.includes(target)) {
    history.replace &&
      history.replace(filterXSS(`${target}?projectId=${projectId}`));
  }
};
// insight redirect logic in here
const initialSelectedResource = (historyState, setter, initialResourceName) => {
  const { segment, category } = historyState;

  if (!segment || !category) {
    return;
  }

  const id =
    segment === SEGMENTS.companyoverview ? category : fixModuleName(category);
  const _category = Object.keys(allRightComponent).find(
    (componentName) => componentName === category,
  )
    ? category
    : initialResourceName;
  setter(id, _category);
};

const getSourceUrl = (data = {}) => ({
  buyer: { link: data.buyerSourceUrl, tip: data.buyerSourceUrlTooltip },
  buyerManualInputFlag: data.buyerManualInputFlag,
  targetManualInputFlag: data.targetManualInputFlag,
  target: {
    link: data.targetSourceUrl,
    tip: data.targetSourceUrlTooltip,
  },
});

const getMenuTitle = (key, originPermissions = []) => {
  if (originPermissions.length) {
    return originPermissions?.find((i) => i.value === key)?.label;
  }
  return SEGMENTS[key];
};

// const getMenuList = ({
//   isClient,
//   sectionsPermission,
//   internalSectionsPermission,
// }) => {
//   const { analysisPermission } = sectionsPermission;
//   const { analysisPermission: internalPermission } = internalSectionsPermission;

//   if (!isClient) {
//     return internalPermission.map((m) => ({ id: m, title: SEGMENTS[m] }));
//   }
//   return analysisPermission.map((m) => ({ id: m, title: SEGMENTS[m] }));
// };

const AnalysisPortal = (props) => {
  const {
    history,
    location,
    // projectId,
    // permission,
    // sectionsPermission,
    // internalSectionsPermission,
    // userInfo: { role },
    match: {
      params: { segmentId },
    },
    saveKeyContactsData,
    isShowContacts,
    resetFinancialDatas,
    clearForceUpdate,
    singleCompanyInstance,
    accessibleModules,
    instanceType,
    analysisOriginPermissions,
  } = props;
  const { projectId } = getProjectInfoFromLocation(history.location);
  const [analysisData, setAnalysisData] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(SEGMENTS[segmentId]);
  const [isGlobalEditing, setIsGlobalEditing] = useState(false);
  const [settingOpen, setSettingOpen] = useState(false);
  const editActionHandler = () => {
    setIsGlobalEditing(true);
  };
  const setShowKeyContacts = (bool) => {
    dispatch(action.setShowKeyContacts(bool));
  };

  // const [segmentId, setSegmentId] = useState(Object.keys(SEGMENTS)[0]);
  const [resourceId, setResourceId] = useState(
    valueForChoosedMenu.get(selectedMenu) &&
      valueForChoosedMenu.get(selectedMenu).resourceId,
  );
  const [resourceName, setResourceName] = useState(
    valueForChoosedMenu.get(selectedMenu) &&
      valueForChoosedMenu.get(selectedMenu).resourceName,
  );
  const [buyerManualInputFlag, setBuyerManualInputFlag] = useState(false);
  const [targetManualInputFlag, setTargetManualInputFlag] = useState(false);

  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const [dropdownList, setDropdownList] = useState(null);

  const menuList = getMenuList({
    permissionCodes: accessibleModules?.moduleList,
    originPermissions: analysisOriginPermissions,
  });
  const dropdownTitle = getMenuTitle(segmentId, analysisOriginPermissions);

  const chooseMenu = (id, isOpen, notInitial) => {
    if (selectedMenu === SEGMENTS[id] || !id) {
      return;
    }
    const newMenu = SEGMENTS[id];

    // debugger;
    // const projectName = getSessionStorage('projectName');
    // const params = encodeURIComponent(
    //   `currentId=${projectId}&&projectName=${projectName}`,
    // );

    history.replace(`/analysis/${id}?${generateProjectUrlSearch(projectId)}`);

    setSelectedMenu(newMenu);

    if (notInitial) {
      return;
    }
    setResourceId(
      valueForChoosedMenu.get(newMenu) &&
        valueForChoosedMenu.get(newMenu).resourceId,
    );
    setResourceName(
      valueForChoosedMenu.get(newMenu) &&
        valueForChoosedMenu.get(newMenu).resourceName,
    );
  };

  const handleInsightModalShow = (config) => {
    modalRef.current && modalRef.current.show(config);
  };

  const filterErrorData = (data = []) =>
    data?.filter?.((item) => item.info && item.info.value) || [];

  const changeAnalysisData = async () => {
    const { state } = location;
    const historyState = state || {};
    dispatch(actions.changeLoading(true));
    if (!projectId || projectId === 'null') {
      return console.log('incorrect project id');
    }
    dispatch(actions.getProjectInfo(projectId)); // update company name
    let response = await API.getAnalysisData(projectId, selectedMenu);
    if (selectedMenu === SEGMENTS.keycontact) {
      response.table = resortFun(response.table);
      saveKeyContactsData(formatFun(response.table));
    }
    setBuyerManualInputFlag(Boolean(response?.buyerManualInputFlag));
    setTargetManualInputFlag(Boolean(response?.targetManualInputFlag));
    if (selectedMenu === SEGMENTS.companyoverview) {
      if (response && response.buyerManualInputFlag) {
        response.table[1].buyer = sliceStr({ str: response.table[1].buyer });
      }
      if (response && response.targetManualInputFlag) {
        response.table[1].target = sliceStr({ str: response.table[1].target });
      }
    }
    if (selectedMenu === SEGMENTS.financials) {
      // 这是为了在financial页面有下拉选择LTM和FY**而区分的数据
      const buyerMarketCapDate = new Date(
        response?.buyerMarketCapDate,
      ).getTime();
      const targetMarketCapDate = new Date(
        response?.targetMarketCapDate,
      ).getTime();
      const latestDate =
        buyerMarketCapDate > targetMarketCapDate
          ? response?.buyerMarketCapDate
          : response?.targetMarketCapDate;
      setDropdownList(response?.dropdownList);

      if (latestDate) {
        response.table.map((item) => {
          if (item.info.value === 'Market Cap') {
            item.info.date = moment(latestDate).format('MM/DD/YYYY');
          }
          return item;
        });
        response.tableForLTM &&
          response.tableForLTM.map((item) => {
            if (item.info.value === 'Market Cap') {
              item.info.date = moment(latestDate).format('MM/DD/YYYY');
            }
            return item;
          });
      }

      response.tableForLTM &&
        response.tableForLTM.map((item, i) => {
          if (isUuid(item.info.resourceId)) {
            item.info.resourceIdFy = response.table[i].info.resourceId;
            item.info.hasInsight = response.table[i].info.hasInsight;
          }
          return item;
        });

      response = {
        table: formatFinancials(response.table),
        tableForLTM: formatFinancials(response.tableForLTM),
        ...getSourceUrl(response),
      };
    }
    response.table = filterErrorData(response.table);

    setAnalysisData({ [selectedMenu]: response });
    dispatch(actions.changeLoading(false));

    //when there is 'category' in location.state,show insight modal
    if (historyState.category && !historyState.noModal) {
      handleInsightModalShow(historyState);
      clearLocationState(
        props.history,
        `${ANALYSIS_BREADCRUMB_PREFIX}${segmentId}`,
        projectId,
      );
    }
  };
  const changeResource = (resourceId, resourceName) => {
    setResourceId(resourceId);
    setResourceName(resourceName);
  };

  useEffect(() => {
    changeAnalysisData();
  }, [selectedMenu, isShowContacts, projectId]);

  useEffect(() => {
    const state = location.state || {};

    initialSelectedResource(
      { ...state, segment: segmentId },
      changeResource,
      resourceName,
    );

    const resetInitialResource =
      Boolean(state.category) &&
      !UNCLICKABLE_RESOURCE_NAME.includes(state.category);

    chooseMenu(state.menuId, undefined, resetInitialResource);
  }, [location, segmentId]);

  //clear sideeffects
  useEffect(
    () => () => {
      clearForceUpdate();
    },
    [],
  );

  if (!analysisData) {
    return null;
  }
  if (!analysisData[selectedMenu]) {
    return null;
  }
  if (CSTMZ_SEGMENTS.includes(selectedMenu)) {
    return (
      <AnalysisCstmzWrapper
        title={dropdownTitle}
        segmentId={segmentId}
        dropdownList={menuList}
        sendData={chooseMenu}
        permission={segmentId}
        refetch={changeAnalysisData}
        data={analysisData[selectedMenu]}
      />
    );
  }

  return (
    <div className="analysisContainer">
      <InsightModal
        ref={modalRef}
        segment={segmentId}
        closeModalCallback={changeAnalysisData}
      />
      <div className="leftContent">
        <div className="summary-header-with-setting">
          <Dropdown
            title={dropdownTitle}
            // TODO: Progressively add analysis modules ready for stg
            list={
              analysisData[selectedMenu].isSingleCompany
                ? menuList.filter((e) => ['companyoverview'].includes(e.id))
                : menuList
            }
            sendData={chooseMenu}
            permission={segmentId}
          />
          {selectedMenu === SEGMENTS.companyoverview ||
          selectedMenu === SEGMENTS.operationalfootprint ? (
            <FieldSettings
              selectedMenu={selectedMenu}
              fields={analysisData[selectedMenu]?.table || []}
              refetch={changeAnalysisData}
              childrenFields={expandData}
              setSettingOpen={setSettingOpen}
            />
          ) : null}
          {selectedMenu === SEGMENTS.financials ? (
            <div className="financials-header-setting">
              <FieldSettings
                selectedMenu={selectedMenu}
                fields={analysisData[selectedMenu]?.table || []}
                refetch={changeAnalysisData}
                childrenFields={expandData}
                setSettingOpen={setSettingOpen}
              />
              <FinancialUpload
                updateFinancialData={() => {
                  changeAnalysisData();
                  resetFinancialDatas(projectId);
                }}
              />
            </div>
          ) : null}
          {selectedMenu === SEGMENTS.gotomarket ? (
            <div className="gotomarket-header-setting">
              <FieldSettings
                selectedMenu={selectedMenu}
                fields={analysisData[selectedMenu]?.table || []}
                refetch={changeAnalysisData}
                childrenFields={expandData}
                setSettingOpen={setSettingOpen}
              />
              <GlobalEditButton
                selectedMenu={selectedMenu}
                actionHandler={editActionHandler}
                isEditing={isGlobalEditing}
                keyContactHandler={() => {
                  setShowKeyContacts(true);
                }}
                isShowContacts={isShowContacts}
              />
            </div>
          ) : null}
        </div>
        <AnalysisSummary
          currentSubmoduleName={dropdownTitle}
          data={analysisData[selectedMenu]}
          resourceName={resourceName}
          changeResource={changeResource}
          refetch={changeAnalysisData}
          selectedMenu={selectedMenu}
          dropdownList={dropdownList}
          showModal={handleInsightModalShow}
          hasComment={[SEGMENTS.companyoverview, SEGMENTS.financials].includes(
            selectedMenu,
          )}
          isGlobalEditing={isGlobalEditing}
          setIsGlobalEditing={setIsGlobalEditing}
          isSettingOpen={settingOpen}
        />
        <Footer selectedMenu={selectedMenu} data={analysisData[selectedMenu]} />
      </div>
      {selectedMenu ===
      (SEGMENTS.keycontact || SEGMENTS.dealrationale) ? null : (
        <div className="rightContent">
          <AnalysisDetail
            projectId={projectId}
            //TODO: Should delete isSingleCompany verification after Right side ready
            resourceId={
              analysisData[selectedMenu].isSingleCompany &&
              !RESOURCE_HAS_SINGLECHART.includes(resourceName)
                ? false
                : resourceId
            }
            resourceName={resourceName}
            refetch={changeAnalysisData}
            data={analysisData[selectedMenu].detail || analysisData}
            buyerManualInputFlag={buyerManualInputFlag}
            targetManualInputFlag={targetManualInputFlag}
            isSingleCompany={analysisData[selectedMenu].isSingleCompany}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ analysis, projects, login, common }) => ({
  isShowContacts: analysis.isShowContacts,
  // permission: projects.userPermission,
  // sectionsPermission: projects.sectionsPermission,
  // internalSectionsPermission: projects.internalSectionsPermission,
  userInfo: login.userInfo || {},
  projectId: common.currentId,
  singleCompanyInstance: projects.saveData.singleCompanyInstance,
  companyInstance: common.projectCompanyInfo.companyInstance,
  accessibleModules: projects?.originAccessibleModules,
  analysisOriginPermissions: projects?.customizedModules?.find?.(
    (i) => i.value === 'analysis',
  )?.originPermissions,
  instanceType: common.projectCompanyInfo.instanceType,
});

const mapDispatchToProps = (dispatch) => ({
  saveKeyContactsData(data) {
    dispatch(actions.saveKeyContactsData(data));
  },
  resetFinancialDatas(id) {
    dispatch(actions.fetchTotalRevenue(id, true));
    dispatch(actions.fetchMarketCapData(id));
    dispatch(actions.fetchStockData(id));
    dispatch(actions.changeForceupdateProjectIds([id])); //update trigger for Gross Profit, Income * 2,EPS,subsidiary
  },
  clearForceUpdate() {
    dispatch(actions.changeForceupdateProjectIds());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(AnalysisPortal));
